var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 62.488,
    viewBox: "0 0 75 62.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_325",
    "data-name": "Trac\\xE9 325",
    d: "M0,43.944H75V-18.544H0Z",
    transform: "translate(0 18.544)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_163",
    "data-name": "Groupe 163",
    transform: "translate(21 15.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162",
    "data-name": "Groupe 162",
    transform: "translate(-21 -15.544)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_155",
    "data-name": "Groupe 155",
    transform: "translate(52.168 11.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_318",
    "data-name": "Trac\\xE9 318",
    d: "M7.1,24.851H-1.925A1.072,1.072,0,0,1-3,23.779a1.072,1.072,0,0,1,1.072-1.072H7.1A10.59,10.59,0,0,0,17.693,12.116a10.766,10.766,0,0,0-.084-1.318A10.848,10.848,0,0,0,6.651,1.532H5.815A1.071,1.071,0,0,1,4.743.464a1.177,1.177,0,0,1,.02-.219,17.1,17.1,0,0,0,.067-6.359,16.381,16.381,0,0,0-.815-2.9,1.071,1.071,0,0,1,.6-1.392A1.069,1.069,0,0,1,6-9.81c.007.013.01.027.017.04a18.783,18.783,0,0,1,.917,3.285A19.353,19.353,0,0,1,7.078-.6,12.975,12.975,0,0,1,19.735,10.55,12.733,12.733,0,0,1,8.682,24.766a13.1,13.1,0,0,1-1.584.1Z",
    transform: "translate(2.997 10.487)",
    fill: "#0a369c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_156",
    "data-name": "Groupe 156",
    transform: "translate(40.242 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_319",
    "data-name": "Trac\\xE9 319",
    d: "M.763,1.609A1.07,1.07,0,0,1,.628-.524,18.856,18.856,0,0,1,4.116-.648a1.073,1.073,0,1,1-.125,2.143A16.617,16.617,0,0,0,.9,1.6a.926.926,0,0,1-.138.007",
    transform: "translate(0.322 0.679)",
    fill: "#0a369c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_157",
    "data-name": "Groupe 157",
    transform: "translate(0.002 4.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_320",
    "data-name": "Trac\\xE9 320",
    d: "M15.3,30.042H6.274A12.74,12.74,0,0,1-6.457,17.291a12.137,12.137,0,0,1,.1-1.564A12.969,12.969,0,0,1,6.368,4.577a14.742,14.742,0,0,1,13.887-10.7A19.127,19.127,0,0,1,25.178-12.4a1.064,1.064,0,0,1,1.51.078,1.067,1.067,0,0,1-.074,1.51c-.02.02-.044.037-.064.054A17.017,17.017,0,0,0,21.9-4.589a1.061,1.061,0,0,1-1.048.637l-.2-.017c-.064,0-.125-.013-.192-.013A12.565,12.565,0,0,0,8.252,5.867,1.074,1.074,0,0,1,7.2,6.71h-.5A10.849,10.849,0,0,0-4.246,15.99a10.6,10.6,0,0,0,9.2,11.831,11.3,11.3,0,0,0,1.3.084h9.027a1.072,1.072,0,1,1,0,2.143Z",
    transform: "translate(6.457 12.677)",
    fill: "#0a369c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_158",
    "data-name": "Groupe 158",
    transform: "translate(50.811 2.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_321",
    "data-name": "Trac\\xE9 321",
    d: "M2.675,2.77A1.063,1.063,0,0,1,2,2.531,15.623,15.623,0,0,0-.587.836a1.071,1.071,0,0,1-.4-1.462,1.071,1.071,0,0,1,1.4-.435A18.125,18.125,0,0,1,3.352.866a1.071,1.071,0,0,1-.677,1.9",
    transform: "translate(1.129 1.169)",
    fill: "#0a369c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_159",
    "data-name": "Groupe 159",
    transform: "translate(20.682 28.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_322",
    "data-name": "Trac\\xE9 322",
    d: "M11.823,23.647A16.813,16.813,0,1,1,28.634,6.836,16.811,16.811,0,0,1,11.823,23.647m0-31.48A14.67,14.67,0,1,0,26.494,6.836,14.67,14.67,0,0,0,11.823-7.832Z",
    transform: "translate(4.989 9.979)",
    fill: "#0a369c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_160",
    "data-name": "Groupe 160",
    transform: "translate(36.42 37.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_323",
    "data-name": "Trac\\xE9 323",
    d: "M.754,11.645A1.07,1.07,0,0,1-.318,10.573V-3.842A1.074,1.074,0,0,1,.754-4.914,1.072,1.072,0,0,1,1.825-3.842V10.57A1.069,1.069,0,0,1,.76,11.645Z",
    transform: "translate(0.318 4.914)",
    fill: "#0a369c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_161",
    "data-name": "Groupe 161",
    transform: "translate(31.887 37.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_324",
    "data-name": "Trac\\xE9 324",
    d: "M7.135,4.7a1.071,1.071,0,0,1-.758-.313L2.6.6-1.181,4.383a1.074,1.074,0,0,1-1.516,0,1.074,1.074,0,0,1,0-1.516L1.841-1.669a1.07,1.07,0,0,1,1.513,0h0L7.893,2.867A1.072,1.072,0,0,1,7.135,4.7",
    transform: "translate(3.011 1.982)",
    fill: "#0a369c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.590d8801fb6f23ebd5692a41c78cb342.svg";
export { ForwardRef as ReactComponent };